export default __webpack_public_path__ + "static/media/CROPlogo.1ccbfeee.png";